import routes from './routes';
import { IModuleProps } from '../core/utils/modules';

export default {
    name: 'chat',
    routes,
} as IModuleProps;
